import { Box } from '@mui/material';
import { styled } from '@mui/system';

const CTABOX = styled(Box)(({ theme }) => ({
  paddingTop: '1rem', // Small padding on top
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));

export default CTABOX;
